/**
 * Кто на том конце звонка: имя и фото из личного диалога пары в реплике (изменение v1.14).
 */
import { faceOf } from '@entities/conversation/display'
import { useConversation } from '@entities/conversation/model'
import type { Availability, PublicPhoto } from '@shared/api/types'

export interface CallPeer {
  name: string
  photo: PublicPhoto | null
  availability: Availability
}

export function useCallPeer(conversationId: string | null): CallPeer {
  const conversation = useConversation(conversationId)
  if (!conversation) return { name: 'Собеседник', photo: null, availability: 'available' }
  const face = faceOf(conversation)
  return { name: face.name ?? 'Собеседник', photo: face.photo, availability: face.availability }
}
